"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG_LEVELS = exports.LOGGING_EVENT_EMITTER_CHANNEL = exports.FEATURE_NAME = void 0;
var _features = require("../../loaders/features/features");
const LOG_LEVELS = exports.LOG_LEVELS = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
  TRACE: 'TRACE'
};
const LOGGING_EVENT_EMITTER_CHANNEL = exports.LOGGING_EVENT_EMITTER_CHANNEL = 'log';
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.logging;